import {
  OR_REQUEST_INIT_REGISTRATION_DATA,
  OR_RECEIVE_INIT_REGISTRATION_DATA,
  OR_CHOOSE_ADDRESS,
  OR_ENTER_PHONE,
  OR_CHOOSE_FREQUENCY,
  OR_REQUEST_SLOTS,
  OR_RECEIVE_SLOTS,
  OR_SELECT_TIME_OF_DAY,
  OR_CHOOSE_SLOT,
  OR_SELECT_PAYMENT_METHOD,
  OR_TOGGLE_PHONE_NUMBER_VALIDATION_ERROR,
  OR_REGISTRATION_RESET_DATA,
} from '../../actions/registration/ordersReservedRegistration';
import {
  OR_REGISTRATION_TOGGLE_PANEL,
  PHONE_PANEL,
} from '../../actions/registration/registrationFormPanels';
import { TimeOfDay } from '../../types';

export const initialState = {
  selectedAddressId: null,
  acceptedPhoneNumber: null,
  selectedFrequency: null,
  selectedWeekday: null,
  selectedTimeOfDay: null,
  selectedSlotId: null,
  selectedPaymentMethod: null,
  shouldShowPhoneNumberValidationError: false,
};

const ACTIONS = {
  [OR_REQUEST_INIT_REGISTRATION_DATA]: () => (initialState),
  [OR_RECEIVE_INIT_REGISTRATION_DATA]: ({ state, action }) => (
    { ...state, acceptedPhoneNumber: action.data.smsEnabled ? action.data.smsNumber : '' }
  ),
  [OR_CHOOSE_ADDRESS]: ({ state, action }) => {
    if (action.hasChanged === false) {
      return state;
    }

    return {
      ...state,
      selectedAddressId: action.addressId,
      selectedFrequency: null,
      selectedWeekday: null,
      selectedSlotId: null,
      selectedPaymentMethod: null,
      shouldShowPhoneNumberValidationError: false,
    };
  },
  [OR_ENTER_PHONE]: ({ state, action }) => ({ ...state, acceptedPhoneNumber: action.phoneNumber }),
  [OR_CHOOSE_FREQUENCY]: ({ state, action }) => {
    if (action.hasChanged === false) {
      return state;
    }

    return {
      ...state,
      selectedFrequency: action.frequency,
      selectedWeekday: null,
      selectedSlotId: null,
      selectedPaymentMethod: null,
    };
  },
  [OR_REQUEST_SLOTS]: ({ state, action }) => ({
    ...state, selectedSlotId: null, selectedPaymentMethod: null, selectedWeekday: action.weekday,
  }),
  [OR_RECEIVE_SLOTS]: ({ state, action }) => ({
    ...state, selectedWeekday: action.weekday, selectedTimeOfDay: TimeOfDay.MORNING,
  }),
  [OR_SELECT_TIME_OF_DAY]: ({ state, action }) => ({ ...state, selectedTimeOfDay: action.timeOfDay }),
  [OR_CHOOSE_SLOT]: ({ state, action }) => {
    if (action.hasChanged === false) {
      return state;
    }

    return { ...state, selectedSlotId: action.slotId, selectedPaymentMethod: null };
  },
  [OR_SELECT_PAYMENT_METHOD]: ({ state, action }) => ({ ...state, selectedPaymentMethod: action.paymentMethod }),
  [OR_TOGGLE_PHONE_NUMBER_VALIDATION_ERROR]: ({ state, action }) => ({
    ...state, shouldShowPhoneNumberValidationError: action.shouldShowPhoneNumberValidationError,
  }),
  [OR_REGISTRATION_TOGGLE_PANEL]: ({ state, action }) => {
    if (action.panelKey !== PHONE_PANEL) {
      return state;
    }

    return { ...state, shouldShowPhoneNumberValidationError: false };
  },
  [OR_REGISTRATION_RESET_DATA]: () => (initialState),
};

export default function selectedDataReducer(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
